module.exports = __webpack_public_path__ + "img/c78.7b721062.png";